export const canFindDuplicates = state => state.ui.canFindDuplicates;
export const isSvnMember = state => state.ui.svnMember;
